import Swup from "swup";
import SwupBodyClassPlugin from "@swup/body-class-plugin";
import SwupHeadPlugin from "@swup/head-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";
import SwupScriptsPlugin from "@swup/scripts-plugin";
import SwupPreloadPlugin from "@swup/preload-plugin";

import SwupOverlayTheme from "@swup/overlay-theme";
import SwupFadeTheme from "@swup/fade-theme";
import SwupSlideTheme from "@swup/slide-theme";
import SwupJsPlugin from "@swup/js-plugin";

import swupJsOptions from "./swup.animations";

import initEvents from "./init.events";
import initAnims from "./init.anims";

import { initLoadMore, cleanLoadMore } from "./loadmore";
import { initGetContact, cleanGetContact } from "./getcontact";
import { initGetPress, cleanGetPress } from "./getpress";

import { initSliders, cleanSliders } from "./sliders";
import { initOpener, cleanOpener } from "./opener";
import { initForms, cleanForms } from "./forms";
import { initPopup, cleanPopup } from "./popup.newsletter";
import { initZoom, cleanZoom } from "./zoom";
import { initMobile, cleanMobile } from "./mobile";



import { initCatify } from "./catify";

// const $ = jQuery;
//new SwupScriptsPlugin()

const options = {
  containers: [
   "#swup",
   "#wp-footer",
   "#menu-1",
   "#menu-2",
   "#mobile-menu"
   //  "#menu-topleft",
  //  "#menu-topright",
   ],
  linkSelector:
    'a[href^="' +
    window.location.origin +
    '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup]), a[href^="#"]:not([data-no-swup])',
  plugins: [
    new SwupBodyClassPlugin(),
    new SwupHeadPlugin(),
    new SwupScrollPlugin({
      doScrollingRightAway: false,
      animateScroll: true,
      scrollFriction: 0.25,
      scrollAcceleration: 0.045
    }),
    new SwupScriptsPlugin({
      // contact OK / image product NOT OK
      // head: true,
      // body: false,

      // contact NOT OK / image product OK
      // head: false,
      // body: true,

      // contact  NOT OK/ image product OK
      head: true,
      body: true
    }),
    new SwupPreloadPlugin(),

    new SwupJsPlugin(swupJsOptions)
    // new SwupFadeTheme(),

    //  new SwupOverlayTheme({
    //   color: '#F8EBE9',
    //  duration: 400,
    //  direction: 'to-bottom'
    // })
  ]
};

const init = () => {
   console.log("init");
  const browserSync = document.getElementById("__bs_script__");
  browserSync && browserSync.setAttribute("data-swup-ignore-script", true);

  initEvents();
  initAnims();

  initLoadMore();
  initGetContact();
  initGetPress();
  initSliders();
  initOpener();
  initForms();
  initPopup();
  initZoom();
  initMobile();

  initCatify();
};

const replaceContent = e => {
   console.log("contentReplaced -> init");

  // if ( document.triggerReady ) document.triggerReady( true );
  // if ( jQuery &&  jQuery.readyFn ) $.readyFn.execute( document, true );
  // if ( window.triggerLoad ) window.triggerLoad( true );

  // window.document.dispatchEvent(new Event("DOMContentLoaded", {
  //     bubbles: true,
  //     cancelable: true
  //   }));

  

  init();
};

const cleanUp = e => {
  // console.log("willReplaceContent -> cleanUp");

  // document.body.innerHTML=document.body.innerHTML;
  //  $(document).off();
  //  $(document.body).off();

  if(typeof(sbi_js_exists) !== 'undefined'){
    sbi_js_exists = undefined;
  }

  cleanLoadMore();
  cleanGetContact();
  cleanGetPress();
  cleanSliders();
  cleanOpener();
  cleanForms();
  cleanPopup();
  cleanZoom();
  cleanMobile();


  window.sukiPro && document.removeEventListener("DOMContentLoaded", window.sukiPro.initAll);
  window.suki && document.removeEventListener("DOMContentLoaded", window.suki.initAll);
};
init();
// replaceContent();

const swup = new Swup(options); // only this line when included with script tag
swup.on("contentReplaced", replaceContent);
swup.on("willReplaceContent", cleanUp);
